import React from 'react';
import Loading from 'src/components/Loading';
import { getSection } from 'src/hooks/useContentful/getSection';
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent';

import { Wrapper, Container, TextWrap, Title, Image, ContainerImagem } from './style';

export default function TagVeloe() {

  const { data, isLoading } = useFetchContent();
  const {
    titulo,
    titleColor,
    tag,
  } = getSection({
    sectionName: 'landingSecaoTagVeloe',
    data,
  });

  const { file, title } = tag.fields;

  if (isLoading || !data) return <Loading />;
	return (
		<Wrapper>
			<Container>
        <ContainerImagem>
				  <Image src={`https://${file.url}`} alt={title} />
        </ContainerImagem>
				<TextWrap>
					<Title color={titleColor}>{titulo}</Title>
				</TextWrap>
			</Container>
		</Wrapper>
	)
}
